import React from 'react';

const StrikedIcon = ({ icon, color = 'black', thickness = 1, angle = -45, style = {} }) => {
    return (
        <div style={{ position: 'relative', display: 'inline-block', ...style }}>
            {icon}
            <div
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: 0,
                    width: '100%',
                    height: thickness,
                    backgroundColor: color,
                    transform: `rotate(${angle}deg)`,
                    transformOrigin: 'center',
                    pointerEvents: 'none',
                }}
            />
        </div>
    );
};

export default StrikedIcon;